import React from 'react';
import { compose } from 'redux';
import { requestAnimationFrameWithFallback } from '../utils';

import withCookieHeaderHeight from '../../components/withCookieHeaderHeight';
import { HEADER_HEIGHT as TOP_PADDING } from '../constants';

const getFooterHeight = () => {
    const footerEl = document.getElementsByClassName('eds-global-footer')[0];

    // Adding 180px to footer height value in order to account for the
    // trending searches section added to the maincontent of the page.
    return footerEl ? footerEl.getBoundingClientRect().height : 300;
};

const getFooterHeightInView = () => {
    const footerEl = document.getElementsByClassName('eds-global-footer')[0];

    if (!footerEl) {
        return 54;
    }

    const footerHeightInView =
        window.innerHeight - footerEl.getBoundingClientRect().y;

    return footerHeightInView > 0 ? footerHeightInView : 0;
};

const checkIfScrolledToBottom = () =>
    window.innerHeight + window.scrollY >=
    document.body.offsetHeight - getFooterHeight();

const withStickyScroll = (Component) =>
    class StickyScrollingContainer extends React.PureComponent {
        state = {
            elementTop: 0,
            elementWidth: 0,
            shouldScroll: true,
        };

        componentDidMount() {
            this._isMounted = true;

            this.updateMeasurements();
        }

        componentWillUnmount() {
            this._isMounted = false;
        }

        updateMeasurements = () => {
            if (this._isMounted) {
                this.updateWidth();
                this.updateScrollPos();

                requestAnimationFrameWithFallback(this.updateMeasurements);
            }
        };

        // Since position: fixed takes this element out of the flow, it loses its width.
        // This is especially a problem with EDS grid classes.
        // Therefore, we use a dummy div to capture the correct width and
        // manually set it on the styles.
        // We have to do this again when the page resizes.
        updateWidth = () => {
            this.setState({
                elementWidth: this._rootNode.clientWidth,
            });
        };

        updateScrollPos = () => {
            const adjustedTopPosition =
                this._rootNode.getBoundingClientRect().top - TOP_PADDING;
            const elementHeight = `calc(100vh - ${TOP_PADDING}px - ${getFooterHeightInView()}px - ${
                this.props.cookieHeaderHeight
            }px)`;

            this.setState({ elementTop: adjustedTopPosition, elementHeight });
        };

        _setRef = (node) => {
            this._rootNode = node;
        };

        _setRefForWrapped = (node) => {
            this._rootNodeWrapped = node;
        };

        _setShouldScroll = (val) => {
            this.setState({ shouldScroll: val });
        };

        render() {
            const width = this.state.elementWidth;
            const height = this.state.elementHeight;

            let styleProps = {
                style: {
                    position: 'relative',
                    width: 'inherit',
                    height: 'inherit',
                    zIndex: 1,
                },
            };

            if (
                typeof window === 'object' &&
                this._rootNodeWrapped &&
                checkIfScrolledToBottom()
            ) {
                styleProps = {
                    style: {
                        position: 'fixed',
                        bottom: getFooterHeight(),
                        width,
                        top: TOP_PADDING + this.props.cookieHeaderHeight,
                        height,
                    },
                };
            } else if (this.state.elementTop < 0) {
                styleProps = {
                    style: {
                        position: 'fixed',
                        top: TOP_PADDING + this.props.cookieHeaderHeight,
                        width,
                        height,
                    },
                };
            }

            return (
                <div>
                    <div
                        ref={this._setRef}
                        height={height}
                        width={this.props.width}
                    />
                    <div ref={this._setRefForWrapped} {...styleProps}>
                        <Component
                            {...this.props}
                            height={height}
                            isFixed={true}
                            setShouldScroll={this._setShouldScroll}
                        />
                    </div>
                </div>
            );
        }
    };

export default compose(withCookieHeaderHeight, withStickyScroll);
